<div class="email-log-headers">
  <div class="page-title">Email Log</div>
  @if (emailLogs.length > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'email-log'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

<div class="filter-search-section">
  <div class="context-filter-wrapper">
    <app-searchable-filter
      [filterBy]="contextFilter"
      [filterByOptions]="contextFilterOptions"
      [label]="'Context:'"
      [placeholder]="'All'"
      (filterByChanged)="onContextFilterChange($event)"
    ></app-searchable-filter>
  </div>
  <div class="search-section-wrapper">
    <app-search-input
      [placeholder]="'Search recipient email...'"
      [(searchQuery)]="searchQuery"
      (searchQueryChange)="onSearchQueryChange($event)"
    ></app-search-input>
  </div>
</div>

<app-table [columns]="tableColumns" [data]="emailLogs" [loading]="loading">
  <ng-template let-email>
    <tr>
      <td>{{ email.recipient_email || "—" }}</td>
      <td class="subject-cell" [title]="email.subject || ''">
        {{ email.subject || "—" }}
      </td>
      <td>
        <span class="context-badge">{{
          formatContext(email.email_context)
        }}</span>
      </td>
      <td>{{ email.reference_id }}</td>
      <td>
        {{ email.sent_at ? (email.sent_at | date: "medium") : "—" }}
      </td>
      <td class="actions">
        <div class="action-icons">
          <a
            href="javascript:void(0)"
            (click)="openDetailPopup(email.id)"
            title="View email"
          >
            View
          </a>
        </div>
      </td>
    </tr>
  </ng-template>
</app-table>

@if (emailLogs.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalEmails"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showDetailPopup && selectedEmailId !== null) {
  <app-email-detail-popup
    [emailId]="selectedEmailId"
    (popupClosed)="closeDetailPopup()"
  ></app-email-detail-popup>
}
